import { lazy } from 'react';

const SettingRoutes = [
    {
        path: '/agent_settings',
        component: lazy(() => import('../../pages/Settings')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/agent_settings/practice-areas',
        component: lazy(() => import('../../pages/Settings/PracticeAreas')),
        meta: {
            action: 'read',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/agent_settings/membership-renewal',
        component: lazy(() => import('../../pages/Settings/MembershipRenewal')),
        meta: {
            action: 'update',
            resource: 'membership-renewal-settings',
        },
    },
];

export default SettingRoutes;
